import React, { Component } from 'react';
import { connect } from 'react-redux';
import 'antd/dist/antd.css';
import './App.css';
import './assets/styles/overwrite.css';
import "antd/dist/antd.css";
import { message, notification, Icon } from 'antd';
import store from './store';
import { push } from 'connected-react-router';
import { alertConstants, notificationConstants } from './constants';
import { commonConstants } from './actions/commonActions';
import { setFetchServiceToken} from './services/FetchService';
import {appSetLoginData} from './actions/appAction';
import { history } from './store';
import { Route, Switch, Redirect } from 'react-router';
import AppLayout from './containers/layouts/AppLayout';
import * as r from 'rethinkdb';
import { HashRouter } from 'react-router-dom';

//- Dashboard Router
import UserListPage from './containers/user/ListPage';
import UserFormPage from './containers/user/AddEditFormPage';
import CommentFormPage from './containers/user/CommentFormPage';
import SettleFormPage from './containers/user/SettleFormPage';
import PermissionFormPage from './containers/user/PermissionAddEditFormPage';
import StateListPage from './containers/area/StateListPage';
import StateFormPage from './containers/area/AddEditStateFormPage';
import CityListPage from './containers/area/CityListPage';
import CityFormPage from './containers/area/AddEditCityFormPage';
import ServiceListPage from './containers/service/ServiceListPage';
import ServiceFormPage from './containers/service/ServiceAddEditFormPage';
import FixtureListPage from './containers/fixture/FixtureListPage';
import FixtureFormPage from './containers/fixture/FixtureAddEditFormPage';
import ProductCategoryListPage from './containers/product/CategoryListPage';
import ProductCategoryFormPage from './containers/product/CategoryAddEditFormPage';
import ProductListPage from './containers/product/ProductListPage';
import ProductFormPage from './containers/product/ProductAddEditFormPage';
import WarehouseProductListPage from './containers/warehouse/WarehouseProductListPage';
import WarehouseListPage from './containers/warehouse/WarehouseListPage';
import WarehouseInventoryListPage from './containers/warehouse/WarehouseInventoryListPage';
import WarehouseFormPage from './containers/warehouse/WarehouseAddEditFormPage';
import TransactionListPage from './containers/transaction/TransactionListPage';
import TransactionFormPage from './containers/transaction/TransactionAddEditFormPage';
import DashboardPage from './containers/dashboard/DashboardPage';
import OrderListPage from './containers/order/OrderListPage';
import OrderAddEditPage from './containers/order/OrderAddEditFormPage';
import AssignPage from './containers/order/AssignFormPage';
import ChangeDescForm from './containers/order/ChangeDescFormPage';
import AssignChangePage from './containers/order/AssignChangeFormPage';
import CancelPage from './containers/order/CancelFormPage';
import PendingPage from './containers/order/PendingFormPage';
import CallPage from './containers/order/CallFormPage';
import TechPage from './containers/order/TechFormPage';
import CashPage from './containers/order/PayFormPage';
import OrderSettleFormPage from './containers/order/SettleFormPage';
import CancelOrderPage from './containers/order/CancelFormPage';
import BankListPage from './containers/financial/BankListPage';
import BankFormPage from './containers/financial/BankAddEditFormPage';
import FinanceListPage from './containers/financial/FinanceListPage';
import FinanceFormPage from './containers/financial/FinanceAddEditFormPage';
import PosFormPage from './containers/pos/PosAddEditFormPage';
import settingsFormPage from './containers/settings/SettingsAddEditFormPage';
import ReminderListPage from './containers/reminder/ReminderListPage';
import TechnicianReportPage from './containers/report/TechnicianPage';
import ProductsReportPage from './containers/report/ProductsPage';
import PosReportPage from './containers/report/PosPage';
import CityReportPage from './containers/report/CityPage';
import StateReportPage from './containers/report/StatePage';
import RateReportPage from './containers/report/RatePage';
import InvoicePage from './containers/report/InvoicePage';
import TicketsPage from './containers/report/TicketsPage';
import GuaranteeOrderListPage from './containers/guarantee/OrderListPage';
import GuaranteeListPage from './containers/guarantee/GuaranteeListPage';
import ApplyGuaranteePage from './containers/guarantee/ApplyGuaranteePage';
import UploadFormPage from './containers/upload/UploadFormPage';
import { LOGIN_DATA } from './services/AuthService'
import {CookieStore, ImmortalStorage, LocalStorageStore} from "immortal-db";

//- Login/Register Router
import RegisterPage from './containers/login/RegisterPage';
import LoginPage from './containers/login/LoginPage';
import AssignForm from "./components/order/AssignForm";
import CancelPaidFormPage from './containers/order/CancelPaidFormPage';


/* -------- --------------  --------*/
/* -------  App Container   --------*/
/* -------- --------------  --------*/
const mapStateToProps = state => {
  return {
    isLogin:state.app.isLogin,
    router: state.router,
    alert: state.alert,
    location: state.router.location,
    redirectTo: state.common.redirectTo,
    notification: state.notification
  }
}

const mapDispatchToProps = dispatch => ({
  setLoginData:(token,userData)=>{
    dispatch(appSetLoginData(token, userData))
    setFetchServiceToken(token)  //--> set token for FETCH service to send auto `Authorization` Header
  },
  onRedirected: () =>
    dispatch({ type: commonConstants.REDIRECTED }),
  onLoad: (currentUser, token) =>
    dispatch({ type: commonConstants.APP_LOAD, user: currentUser, token: token }),
  onClearAlerts: () =>
    dispatch({type: alertConstants.CLEAR}),
  onClearNotifications: () =>
    dispatch({type: notificationConstants.CLEAR})
});

const makeNotify = (messageType, message) => {
  var iconType = (messageType === 'success') ? 'smile' : 'frown';
  var twoToneColor = (messageType === 'success') ? '#52c41a': '#e51616';
  notification.open({
    duration: 3,
    message: 'پیام سیستمی',
    description: message,
    icon: <Icon type={iconType} theme="twoTone" twoToneColor={twoToneColor} style={{ color: '#108ee9', fontSize: '36px' }} />,
  });
}

const makeAlert = (messageType, body) => {
  switch(messageType) {
    case 'success':
      message.success(body, 3);
      break;
    case 'error':
      message.error(body, 3);
      break;
    default:
      return;
  }
}

const stores = [CookieStore, LocalStorageStore];
const db = new ImmortalStorage(stores);


/* ------- ------------- --------*/
/* ------- App Component --------*/
/* ------- ------------- --------*/
class App extends Component {
  constructor(props) {
    super(props);
    history.listen((location, action) => {
        props.onClearAlerts();
    });
    this.state ={
      isReady:false
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.redirectTo) {
      store.dispatch(push(nextProps.redirectTo));
      this.props.onRedirected();
    }
    if (nextProps.alert && nextProps.alert.messageType && nextProps.alert.message) {
      makeAlert(nextProps.alert.messageType, nextProps.alert.message);
      nextProps.onClearAlerts();
    }

    if (nextProps.notification && nextProps.notification.messageType && nextProps.notification.message) {
      makeNotify(nextProps.notification.messageType, nextProps.notification.message);
      nextProps.onClearNotifications();
    }
  }


  async componentDidMount() {
    // const token = window.localStorage.getItem('JWT_TOKEN');
    const token = await db.get(LOGIN_DATA);
    let currentUser = token ? token : null;
    if(token){
     this.props.setLoginData(token, currentUser);
    }
    this.setState({isReady:true});

    //notification
    // var r = require('rethinkdb');

    r.connect({host: 'el.abci.ir', port: 28015, db: 'ab30', user: 'ab30', password: 'FSDFDSFDH75676GHFHFGH', }, function(err, conn) {
      // if (err) console.log(err);
      // console.log('conn',conn)
      r.table('messages').changes().run(conn, function(err, cursor) {
        if (err) throw err;
        cursor.each(function(err, row) {
          if (err) throw err;
          console.log('json',JSON.stringify(row, null, 2));
        });
      });
    });
    // var ReactRethinkdb = require('react-rethinkdb');
    // var r = ReactRethinkdb.r;
    //
    // ReactRethinkdb.DefaultSession.connect({
    //   host: 'el.abci.ir',          // hostname of the websocket server
    //   port: 80,                 // port number of the websocket server
    //   path: '/',                  // HTTP path to websocket route
    //   secure: false,              // set true to use secure TLS websockets
    //   db: 'ab30',                 // default database, passed to rethinkdb.connect
    //   autoReconnectDelayMs: 2000, // when disconnected, millis to wait before reconnect
    //   user: 'ab30',
    //   password: 'FSDFDSFDH75676GHFHFGH',
    // });



    // var App = React.createClass({
    //   mixins: [ReactRethinkdb.DefaultMixin],
    //
    //   observe: function (props, state) {
    //     return {
    //       turtles: new ReactRethinkdb.QueryRequest({
    //         query: r.table('messages'), // RethinkDB query
    //         changes: true,             // subscribe to realtime changefeed
    //         initial: [],               // return [] while loading
    //       }),
    //     };
    //   },
    //
    //   handleSubmit: function (event) {
    //     event.preventDefault();
    //     var nameInput = this.refs.firstName;
    //     var query = r.table('messages');
    //     nameInput.value = '';
    //     ReactRethinkdb.DefaultSession.runQuery(query);
    //   },
    // })
    // r.connect({host: 'abci.ir', port: 28015, db: 'ab30', user: 'ab30', password: 'FSDFDSFDH75676GHFHFGH', timeout: 20}, function(err, conn) {
    //   if (err) console.log(err);
    //   r.table('messages').changes().run(conn, function(err, cursor) {
    //     if (err) throw err;
    //     cursor.each(function(err, row) {
    //       if (err) throw err;
    //       makeNotify('smile', JSON.stringify(row, null, 2));
    //       // console.log(JSON.stringify(row, null, 2));
    //     });
    //   });
    // });
  }

  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      this.onRouteChanged();
    }
  }

  onRouteChanged() {
    window.location.reload();
  }

  render() {

    if(this.state.isReady === false)
      return null;

    if(this.props.isLogin) //-- if login -> Dashboard Router
      return (
        <HashRouter>
        <AppLayout>
          <div className="App">
            <Switch>
              <Route exact path="/" component={DashboardPage} />
              <Route exact path="/user/list" component={UserListPage} />
              <Route exact path="/user/add" component={UserFormPage} />
              <Route exact path="/user/edit/:id" component={UserFormPage} />
              <Route exact path="/user/settle/:id" component={SettleFormPage} />
              <Route exact path="/user/comment/:id" component={CommentFormPage} />
              <Route exact path="/user/permissions/:id" component={PermissionFormPage} />
              <Route exact path="/state/list" component={StateListPage} />
              <Route exact path="/state/add" component={StateFormPage} />
              <Route exact path="/state/edit/:id" component={StateFormPage} />
              <Route exact path="/city/list" component={CityListPage} />
              <Route exact path="/city/add" component={CityFormPage} />
              <Route exact path="/city/edit/:id" component={CityFormPage} />
              <Route exact path="/service/list" component={ServiceListPage} />
              <Route exact path="/service/add" component={ServiceFormPage} />
              <Route exact path="/service/edit/:id" component={ServiceFormPage} />
              <Route exact path="/fixture/add" component={FixtureFormPage} />
              <Route exact path="/fixture/edit/:id" component={FixtureFormPage} />
              <Route exact path="/fixture/list" component={FixtureListPage} />
              <Route exact path="/product-category/list" component={ProductCategoryListPage} />
              <Route exact path="/product-category/add" component={ProductCategoryFormPage} />
              <Route exact path="/product-category/edit/:id" component={ProductCategoryFormPage} />
              <Route exact path="/product/list" component={ProductListPage} />
              <Route exact path="/product/add" component={ProductFormPage} />
              <Route exact path="/product/edit/:id" component={ProductFormPage} />
              <Route exact path="/warehouse/add/:product_id" component={WarehouseFormPage} />
              <Route exact path="/warehouse/product/:id" component={WarehouseListPage} />
              <Route exact path="/warehouse/state/:id" component={WarehouseListPage} />
              <Route exact path="/warehouse/technician/:id" component={WarehouseListPage} />
              <Route exact path="/warehouse/technician/:id/inventory" component={WarehouseInventoryListPage} />
              <Route exact path="/warehouse/order/:id" component={WarehouseListPage} />
              <Route exact path="/warehouse/list/product/:id" component={WarehouseProductListPage} />
              <Route exact path="/transaction/add/:userId" component={TransactionFormPage} />
              <Route exact path="/transaction/list/:userId" component={TransactionListPage} />
              <Route exact path="/transaction/list" component={TransactionListPage} />
              <Route exact path="/order/list" component={OrderListPage} />
              <Route exact path="/order/add" component={OrderAddEditPage} />
              <Route exact path="/order/add/:mob" component={OrderAddEditPage} />
              <Route exact path="/order/add/:mob/:userId" component={OrderAddEditPage} />
              <Route exact path="/order/list/:userId" component={OrderListPage} />
              <Route exact path="/order/list/technician/:userId" component={OrderListPage} />
              <Route exact path="/order/list/customer/:userId" component={OrderListPage} />
              <Route exact path="/order/assign/:orderId" component={AssignPage} />
              <Route exact path="/order/changedesc/:orderId" component={ChangeDescForm} />
              <Route exact path="/order/assign-change/:orderId" component={AssignChangePage} />
              <Route exact path="/order/cancel/:orderId" component={CancelPage} />
              <Route exact path="/order/new/invoice/:orderId" component={CancelPaidFormPage} />
              <Route exact path="/order/pending/:orderId" component={PendingPage} />
              <Route exact path="/order/call/:orderId" component={CallPage} />
              <Route exact path="/order/cancel/:orderId" component={CancelOrderPage} />
              <Route exact path="/order/tech/:orderId" component={TechPage} />
              <Route exact path="/order/cash/:orderId" component={CashPage} />
              <Route exact path="/document/list" component={FinanceListPage} />
              <Route exact path="/order/settle/:id" component={OrderSettleFormPage} />
              <Route exact path="/document/add" component={FinanceFormPage} />
              <Route exact path="/bank/list" component={BankListPage} />
              <Route exact path="/bank/add" component={BankFormPage} />
              <Route exact path="/pos/:id" component={PosFormPage} />
              <Route exact path="/settings" component={settingsFormPage} />
              <Route exact path="/reminder" component={ReminderListPage} />
              <Route exact path="/report/pos" component={PosReportPage} />
              <Route exact path="/report/technician" component={TechnicianReportPage} />
              <Route exact path="/report/products" component={ProductsReportPage} />
              <Route exact path="/report/city" component={CityReportPage} />
              <Route exact path="/report/state" component={StateReportPage} />
              <Route exact path="/report/rate" component={RateReportPage} />
              <Route exact path="/report/invoice" component={InvoicePage} />
              <Route exact path="/report/tickets" component={TicketsPage} />
              <Route exact path="/upload" component={UploadFormPage} />
              <Route exact path="/guarantee/inquiry" component={GuaranteeOrderListPage} />
              <Route exact path="/guarantee" component={GuaranteeListPage} />
              <Route exact path="/guarantee/inquiry/:inquiryId" component={ApplyGuaranteePage} />

            </Switch>
          </div>
        </AppLayout>
        </HashRouter>
      );
    else //-- if Not Login  -> Login/Register Router
    return (
      <HashRouter>
      <AppLayout>
        <div className="App">
            <Switch>
              <Route exact path="/" component={LoginPage} />
              <Route path="/login" component={LoginPage} />
              <Route path="/register" component={RegisterPage} />
              <Redirect from="*" to="/" />
            </Switch>
        </div>
      </AppLayout>
      </HashRouter>
    );
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(App);
